import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetClaimOrderListRequestDto } from "../../dtos/get-claim-order-list-request-dto";
import type { GetClaimOrderListResponseDto } from "../../dtos/get-claim-order-list-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimOrderListQueryParams = {
  queryParams: GetClaimOrderListRequestDto;
  options?: Omit<UseQueryOptions<GetClaimOrderListResponseDto>, "queryKey">;
};

export const useGetClaimOrderListQuery = ({
  queryParams,
  options
}: UseGetClaimOrderListQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getClaimOrderList({ ...queryParams }).queryKey,
    queryFn: async () =>
      await OrderService.getClaimOrderList({ payload: queryParams }),
    ...options
  });
};
